import { validation } from '@ynap/form-utils';
import { validate as validatePassword } from '@ynap/password-input';

export default function validate(values = {}, props) {
    const { messages, ageConsent, tcConsent, locale } = props;
    const { day, month, year } = values.dateOfBirthGroup || {};
    const formattedDate = day || month || year ? `${day}/${month}/${year ? year : '1900'}` : undefined;
    const errors = {};
    const maxLengths = {
        personTitle: 10,
        firstName: 100,
        lastName: 100,
    };

    if (!values.registrationEmail || !values.registrationEmail.trim()) {
        errors.registrationEmail = messages.errors.required({ field: messages.registrationForm.logonId() });
    } else if (!values.registrationEmail.includes('@') || !values.registrationEmail.includes('.')) {
        errors.registrationEmail = messages.errors.invalid({ field: messages.registrationForm.logonId() });
    }

    // on myaccount both login and register email field are named as logonId
    if (!values.logonId || !values.logonId.trim()) {
        errors.logonId = messages.errors.required({ field: messages.registrationForm.logonId() });
    } else if (!values.logonId.includes('@') || !values.logonId.includes('.')) {
        errors.logonId = messages.errors.invalid({ field: messages.registrationForm.logonId() });
    }

    const passwordError = validatePassword(values.logonPassword, props);
    if (passwordError) {
        errors.logonPassword = passwordError;
    }

    if (values.registrationEmail && values.logonPassword && values.logonPassword.toLowerCase().includes(values.registrationEmail.toLowerCase())) {
        errors.logonPassword = messages.errors.containsLogonId();
    }

    if (!values.personTitle || !values.personTitle.trim() || values.personTitle === 'emptyLabel') {
        errors.personTitle = messages.errors.required({ field: messages.registrationForm.personTitle() });
    } else if (values.personTitle.length > maxLengths.personTitle) {
        errors.personTitle = messages.errors.maxLength({ characters: maxLengths.personTitle });
    }

    if (!values.firstName || !values.firstName.trim()) {
        errors.firstName = messages.errors.required({ field: messages.registrationForm.firstName() });
    } else if (values.firstName.length > maxLengths.firstName) {
        errors.firstName = messages.errors.maxLength({ characters: maxLengths.firstName });
    }

    if (!values.lastName || !values.lastName.trim()) {
        errors.lastName = messages.errors.required({ field: messages.registrationForm.lastName() });
    } else if (values.lastName.length > maxLengths.lastName) {
        errors.lastName = messages.errors.maxLength({ characters: maxLengths.lastName });
    }

    if (values.dateOfBirth) {
        const [day, month, year] = values.dateOfBirth.split('-');
        const formattedDate = day || month || year ? `${day}/${month}/${year ? year : '1900'}` : undefined;
        if (!validation.isValidDob(formattedDate, 1900, ageConsent ? 14 : 0)) {
            errors.dateOfBirth = messages.errors.underAge();
        }
    }

    if (formattedDate) {
        if (!validation.isValidDate(formattedDate)) {
            errors.dateOfBirthGroup = messages.errors.invalidDob({ country: locale.country });
        } else if (!validation.isValidDob(formattedDate, 1900, ageConsent ? 14 : 0)) {
            errors.dateOfBirthGroup = messages.errors.underAge();
        }
    }

    if (values.gdprConsent && values.gdprConsent !== 'true') {
        errors.gdprConsent = messages.registrationForm.gdprConsentError?.();
    }

    if (ageConsent && !values.ageConsent) {
        errors.ageConsent = true;
    }

    if (tcConsent && !values.tcConsent) {
        errors.tcConsent = true;
    }

    return errors;
}
